<h2 style="text-align: center; margin-bottom: 15px">
	{{
		'busy_mode.status'
			| translate
				: {
						status: data.busyMode.active
							? ('busy_mode.active' | translate)
							: ('busy_mode.inactive' | translate)
				  }
	}}
</h2>

<form [formGroup]="form">
	<mat-form-field appearance="outline">
		<mat-label>{{ 'busy_mode.delay_duration' | translate }}</mat-label>

		<mat-select formControlName="delayDuration">
			<mat-option *ngFor="let option of delayOptions" [value]="option">
				{{ option }}
			</mat-option>
		</mat-select>
	</mat-form-field>

	<mat-form-field appearance="outline">
		<mat-label>{{ 'busy_mode.until' | translate }}</mat-label>

		<mat-select formControlName="busyModeUntil">
			<mat-option *ngFor="let option of busyOptions" [value]="option">
				{{ option }}
			</mat-option>
		</mat-select>
	</mat-form-field>
</form>

<button [class.disabled]="form.invalid" (click)="submit()">
	{{
		data.busyMode.active
			? ('busy_mode.disable' | translate)
			: ('busy_mode.enable' | translate)
	}}
</button>
